module.exports = __webpack_public_path__ + "img/602x698 Taxi.921b7d15.jpg";